/**
 * Created by shiyonggao on 2019/12/13.
 */
import qs from "qs";
import { isEmpty } from "lodash";

class loginHandle {
    res;
    store;
    callback;
    menu;
    menuObj;
    constructor(store, res, callback) {
        this.res = res;
        this.store = store;
        this.callback = callback;

        /**测试数据**/
        // this.res['gamelist']['data']['games'] = [];
        // this.res['gamelist']['data']['user'] = {};
        // this.res['gamelist']['data']['user']['email'] = 'gaoshiyong@oasgames.com';

        /**初始化**/
        this.init();
    }

    init() {
        /**设置权限**/
        this.store.commit("updateUserRoles", { res: this.res, ...this.store });

        /**初始化Menu**/
        //this.initMenu();

        /** 用户无游戏列表 **/
        if (
            this.res["gamelist"] &&
            this.res["gamelist"]["data"] &&
            this.res["gamelist"]["data"]["games"] &&
            this.res["gamelist"]["data"]["games"].length === 0
        ) {
            /**用户无权限页面跳转无权限提示页面**/
            if (this.store.rootState.$page !== "noAccess") {
                this.store.rootState.$route("noAccess");
                return;
            }

            /**设置用户信息和游戏信息**/
            this.store.commit("updateAppInfo", this.res);

            /**设置用户无权限对象**/
            this.store.commit("NO_ACCESS_PAGE", {
                args: this.res,
                status: false,
                ...this.store
            });

            /**设置完成回调方法**/
            this.callback(this.res);
            return;
        }
        /*
        let pageKeys = this.store.rootState.$page.split('/'),
            pageInfo = this.store.rootState.$routerMaps;

        pageInfo = pageInfo[pageKeys[0]];
        if (pageInfo && pageInfo.projectType) {
            this.store.state.$helper.cookie.set(
                'odp-projectType',
                pageInfo.projectType
            );
        }
        */
        /**设置游戏信息**/
        this.store.commit("updateAppInfo", this.res);
        this.store.commit("updateAppGameCode");
        // this.store.commit('updateProjectType');

        /**初始化Menu**/
        this.initMenu();
        if (isEmpty(this.menu)) {
            if (this.store.rootState.$page !== "noAccess") {
                this.store.rootState.$route("noAccess");
                return;
            }
            /**设置用户无权限对象**/
            this.store.commit("NO_ACCESS_PAGE", {
                args: this.res,
                status: false,
                ...this.store
            });
            /**设置完成回调方法**/
            this.callback(this.res);
            return;
        }

        this.checkRedirect();

        /**用户有权限访问页面，但是访问在noAccess页面跳转到首页进行路由选择**/
        if (this.store.rootState.$page === "noAccess") {
            this.store.rootState.$route("index");
            return;
        }

        /**用户直接页面检查是否有权限**/
        if (this.checkRole()) {
            /**初始化数据完成回调方法**/
            this.store.dispatch("GET_ACTIVE_GAME_INFO", res => {
                /**首页检查自动路由到业务管理和发行配置**/
                if (this.store.rootState.$page === "index") {
                    this.checkFirst();
                    return;
                }
                this.setProjectType();
                this.callback(this.res);
            });
        } else {
            this.store.rootState.$route("index");
        }
    }
    setProjectType() {
        let page = this.store.rootState.$page.toLocaleLowerCase(),
            type = this.menuObj[page] && this.menuObj[page].projectType;

        this.store.commit("updateProjectType", type);
    }

    checkRedirect() {
        let urlParams = this.store.rootState.$helper.helper.getUrlParams(),
            page = urlParams.page;

        page = decodeURIComponent(page);
        if (page && this.menuObj[page]) {
            this.store.rootState.$helper.helper.route(page);
            return false;
        }
        if (page !== undefined) {
            delete urlParams.page;
            window.history.pushState(null, null, "?" + qs.stringify(urlParams));
        }
    }
    /**
     * 首页访问路由处理
     */
    checkFirst() {
        /**非首次访问带cookie**/
        // if (this.store.state.$helper.cookie.get("odp-projectType")) {
        //     console.log(
        //         "！首次",
        //         this.store.state.$helper.cookie.get("odp-projectType")
        //     );
        //     let projectType = parseInt(
        //         this.store.state.$helper.cookie.get("odp-projectType")
        //     );
        //     if (projectType === 1) {
        //         this.checkDefinedAccessEntry(1);
        //     } else {
        //         this.checkDefinedAccessEntry(2);
        //     }
        //     return;
        // }

        /**公测、封测 ---> 业务管理**/
        let status = this.store.state.$activeGameInfo["game_status"];
        console.log("首次", status);
        if (status === 2 || status === 3) {
            // this.store.state.$helper.cookie.set("odp-projectType", 2);
            this.checkDefinedAccessEntry(2);

            /**除非公测、封测的状态 ---> 发行配置**/
        } else {
            // this.store.state.$helper.cookie.set("odp-projectType", 1);
            this.checkDefinedAccessEntry(1);
        }
    }

    inArrayRole(key) {
        let role = this.store.rootState.$roles;
        let len = role.length;
        let status = false;
        if (key === "") {
            return true;
        }
        for (let i = 0; i < len; i++) {
            if (role[i] === key) {
                if (key === "ROLE_APP_ODP5_CUSTOM_IPBLOCK") {
                    if (this.store.rootState.$isGameAdmin === 1) {
                        status = true;
                    } else {
                        status = false;
                    }
                } else {
                    status = true;
                }
            }
        }

        return status;
    }

    /***
     * 初始化右侧导航
     */
    initMenu() {
        let map = this.store.rootState.$routerMapsDefined;
        let menu = {};
        let pathCount = 0;
        let projectTypeRoute1 = "";
        let projectTypeRoute2 = "";
        let projectTypeRoute1Status = false;
        let projectTypeRoute2Status = false;
        // /**管理员权限设置**/
        if (this.store.rootState.$isAdmin === 1) {
            menu = Object.assign({}, map);
            this.updateMenu(menu);
            return;
        }
        /**非管理员权限设置**/
        for (let key in map) {
            /**有子页面权限设置**/
            if (map[key]["children"]) {
                /**有功能目录权限**/
                if (this.inArrayRole(map[key]["role"])) {
                    if (this.store.rootState.$isGameAdmin === 0) {
                        for (let key in map) {
                            if ( key === "riskManagement") {
                                delete map[key].children.ipBlockView
                            }
                        }
                    }
                    menu[key] = map[key];
                    let temp = "";
                    for (let k in map[key]["children"]) {
                        if (temp) {
                            break;
                        } else {
                            temp = `${key}/${k}`;
                        }
                    }

                    /**设定拥有业务管理权限**/
                    if (key === "watch") {
                        projectTypeRoute2Status = true;
                    }
                    /**设定拥有发行配置权限**/
                    if (key === "gameConfig") {
                        projectTypeRoute1Status = true;
                    }

                    if (!projectTypeRoute1 && map[key]["projectType"] === 1)
                        projectTypeRoute1 = temp;
                    if (!projectTypeRoute2 && map[key]["projectType"] === 2)
                        projectTypeRoute2 = temp;
                    pathCount++;
                } else {
                    let count = 0;
                    let children = map[key]["children"];
                    let temp = {};
                    for (let k in children) {
                        if (this.inArrayRole(children[k]["role"])) {
                            temp[k] = children[k];
                            if (
                                !projectTypeRoute1 &&
                                map[key]["projectType"] === 1
                            )
                                projectTypeRoute1 = `${key}/${k}`;
                            if (
                                !projectTypeRoute2 &&
                                map[key]["projectType"] === 2
                            )
                                projectTypeRoute2 = `${key}/${k}`;
                            /**设定拥有业务管理权限**/
                            if (k === "line") {
                                projectTypeRoute2Status = true;
                            }
                            /**设定拥有发行配置权限**/
                            if (key === "gameConfig") {
                                projectTypeRoute1Status = true;
                            }
                            count++;
                            pathCount++;
                        }
                    }

                    if (count > 0) {
                        menu[key] = {};
                        menu[key]["title"] = map[key]["title"];
                        menu[key]["icon"] = map[key]["icon"];
                        menu[key]["projectType"] = map[key]["projectType"];
                        menu[key]["role"] = map[key]["role"];
                        menu[key]["children"] = temp;
                    }
                }
            } else {
                /**无子页面权限设置**/
                /**无需访问权限页面设置**/
                if (!map[key]["role"]) {
                    menu[key] = map[key];
                } else {
                    /**需访问权限页面设置**/
                    if (this.inArrayRole(map[key]["role"])) {
                        menu[key] = map[key];
                        if (!projectTypeRoute1 && map[key]["projectType"] === 1)
                            projectTypeRoute1 = key;
                        if (!projectTypeRoute2 && map[key]["projectType"] === 2)
                            projectTypeRoute2 = key;
                        pathCount++;
                    }
                }
            }
        }

        /**无访问页面权限**/
        if (pathCount === 0) {
            // this.res["gamelist"]["data"]["games"] = [];
            // this.store.rootState.$helper.localStorage.set(
            //     "odp_gameList",
            //     this.res,
            //     0.5
            // );
            if (this.store.rootState.$page !== "noAccess") {
                this.store.rootState.$route("noAccess");
            }
            this.updateMenu({});
            return;
        }

        /**有访问页面权限**/
        this.store.commit("_updateJumpProjectType", {
            projectTypeRoute1,
            projectTypeRoute2
        });
        this.updateMenu(menu);

        //console.log(map, menu, projectTypeRoute1, projectTypeRoute2);
    }
    getMenuObject() {
        let tmp = {},
            item,
            child;
        for (let key in this.menu) {
            item = this.menu[key];
            if (item.children) {
                for (let k in item.children) {
                    child = item.children[k];
                    tmp[
                        key.toLocaleLowerCase() + "/" + k.toLocaleLowerCase()
                    ] = Object.assign({}, child, {
                        projectType: item.projectType || item._projectType
                    });
                }
            } else {
                tmp[key.toLocaleLowerCase()] = Object.assign({}, item, {
                    projectType: item.projectType || item._projectType
                });
            }
        }

        return tmp;
    }
    updateMenu(menu) {
        this.store.commit("_updateMune", menu);
        this.menu = menu;
        this.menuObj = this.getMenuObject();
    }
    checkDefinedAccessEntry(status) {
        /**管理员权限不检查**/
        if (this.store.rootState.$isAdmin === 1) {
            if (status === 1) {
                this.store.rootState.$route(
                    this.store.rootState.$config.projectTypeRoute1
                );
            }
            if (status === 2) {
                this.store.rootState.$route(
                    this.store.rootState.$config.projectTypeRoute2
                );
            }
            return;
        }

        let defR1 = this.store.rootState.$config.projectTypeRoute1,
            defR2 = this.store.rootState.$config.projectTypeRoute2;

        if (status === 1) {
            if (this.menuObj[defR1.toLocaleLowerCase()]) {
                this.store.rootState.$route(defR1);
            } else if (this.store.rootState.$jumpProjectTypeRoute1) {
                this.store.rootState.$route(
                    this.store.rootState.$jumpProjectTypeRoute1
                );
            } else if (this.store.rootState.$jumpProjectTypeRoute2) {
                this.store.rootState.$route(
                    this.store.rootState.$jumpProjectTypeRoute2
                );
            } else {
                this.checkSystem();
            }
        } else if (status === 2) {
            if (this.menuObj[defR2.toLocaleLowerCase()]) {
                this.store.rootState.$route(defR2);
            } else if (this.store.rootState.$jumpProjectTypeRoute2) {
                this.store.rootState.$route(
                    this.store.rootState.$jumpProjectTypeRoute2
                );
            } else if (this.store.rootState.$jumpProjectTypeRoute1) {
                this.store.rootState.$route(
                    this.store.rootState.$jumpProjectTypeRoute1
                );
            } else {
                this.checkSystem();
            }
        }

        return;
        /**非管理员**/
        // let map = this.store.rootState.$routerMapsDefined;
        // if (
        //     status === 1 &&
        //     !this.inArrayRole(map["gameConfig"]["children"]["baseInfo"]["role"])
        // ) {
        //     console.log(
        //         "baseInfo no role",
        //         this.store.rootState.$jumpProjectTypeRoute1
        //     );
        //     // this.store.rootState.$helper.cookie.set("odp-projectType", status);
        //     if (this.store.rootState.$jumpProjectTypeRoute1) {
        //         this.store.rootState.$route(
        //             this.store.rootState.$jumpProjectTypeRoute1
        //         );
        //     } else {
        //         if (this.store.rootState.$jumpProjectTypeRoute2) {
        //             this.store.rootState.$route(
        //                 this.store.rootState.$jumpProjectTypeRoute2
        //             );
        //             // this.store.commit("_updateShowProjectType", 1);
        //             // this.store.rootState.$helper.cookie.set(
        //             //     "odp-projectType",
        //             //     2
        //             // );
        //         } else {
        //             this.checkSystem();
        //         }
        //     }
        // }

        // /**用户无业务管理默认入口权限**/
        // if (
        //     status === 2 &&
        //     !this.inArrayRole(map["watch"]["children"]["line"]["role"])
        // ) {
        //     // this.store.rootState.$helper.cookie.set("odp-projectType", status);
        //     console.log(
        //         "watch no role",
        //         this.store.rootState.$jumpProjectTypeRoute2
        //     );

        //     /**用户无无业务管理权限默认入口权限，跳转到用户拥有业务管理权限的第一页面入口**/
        //     if (this.store.rootState.$jumpProjectTypeRoute2) {
        //         this.store.rootState.$route(
        //             this.store.rootState.$jumpProjectTypeRoute2
        //         );

        //         /**用户无无业务管理权限任何权限，尝试跳转到发行配置权限**/
        //     } else {
        //         if (this.store.rootState.$jumpProjectTypeRoute1) {
        //             // this.store.commit("_updateShowProjectType", 2);
        //             // this.store.rootState.$helper.cookie.set(
        //             //     "odp-projectType",
        //             //     1
        //             // );
        //             this.store.rootState.$route(
        //                 this.store.rootState.$jumpProjectTypeRoute1
        //             );
        //         } else {
        //             this.checkSystem();
        //         }
        //     }
        // }
    }

    checkSystem() {
        let systemMenu = this.store.rootState.$routerMaps.system.children;
        let firstMenu = "system/";
        for (let key in systemMenu) {
            if (firstMenu === "system/") {
                firstMenu += systemMenu[key]["active"];
                break;
            }
        }
        this.store.rootState.$route(firstMenu);
    }

    /**
     * 用户权限处理
     */
    checkRole() {
        let page = this.store.rootState.$page.toLocaleLowerCase();
        return !!this.menuObj[page];

        // let path = this.store.rootState.$page.split("/");
        // let map = this.store.rootState.$routerMapsDefined;
        // /**管理员权限不判断无权限**/
        // if (this.store.rootState.$isAdmin === 1) {
        //     return true;
        // }

        // if (path.length > 1) {
        //     /**有功能权限不判断无权限**/
        //     if (this.inArrayRole(map[path[0]]["role"])) {
        //         return true;
        //     }

        //     /**访问的页面无权限**/
        //     if (!this.inArrayRole(map[path[0]]["children"][path[1]]["role"])) {
        //         console.error("访问的页面无权限");
        //         this.store.rootState.$route("index");
        //         return false;
        //     }
        // } else {
        //     /**访问的页面无权限**/
        //     if (!this.inArrayRole(map[path[0]]["role"])) {
        //         console.error("访问的页面无权限");
        //         this.store.rootState.$route("index");
        //         return false;
        //     }
        // }

        // console.log(this.store.rootState.$page, this.store.rootState.$roles);
        // return true;
    }
}

export default loginHandle;



// WEBPACK FOOTER //
// ./website/helper/loginHandle.js